import { Product } from '@/lib/index';
import { IMAGES } from '@/assets/images';

export const CATEGORIES = [
  { id: 'baby', name: 'مستلزمات البيبي', image: IMAGES.CATEGORY_BABY_1 },
  { id: 'mother', name: 'مستلزمات الأم', image: IMAGES.CATEGORY_MOTHER_1 },
  { id: 'cosmetics', name: 'مستحضرات التجميل', image: IMAGES.CATEGORY_COSMETICS_2 },
  { id: 'perfume', name: 'العطور', image: IMAGES.PERFUME_1 },
] as const;

export const BRANDS = [
  'Chicco',
  'Pampers',
  'Johnson\'s',
  'Mothercare',
  'Philips Avent',
  'MAC',
  'Maybelline',
  'L\'Oréal',
  'Nivea',
  'Dior',
  'Chanel',
  'Versace',
  'Calvin Klein',
] as const;

export const PRODUCTS: Product[] = [
  // مستلزمات البيبي
  {
    id: '1',
    name: 'عربة أطفال فاخرة',
    price: 2500,
    originalPrice: 3200,
    description: 'عربة أطفال عملية وأنيقة مع نظام تعليق متطور، مقعد قابل للتعديل، ومظلة واقية من الشمس. مناسبة من الولادة حتى 3 سنوات.',
    image: IMAGES.BABY_PRODUCTS_1,
    category: 'baby',
    stock: 15,
    featured: true,
    brand: 'Chicco',
    rating: 4.8,
    reviewCount: 127,
    views: 2543,
    colors: [
      { name: 'رمادي', image: IMAGES.BABY_PRODUCTS_1 },
      { name: 'أزرق', image: IMAGES.CATEGORY_BABY_2 },
    ],
  },
  {
    id: '2',
    name: 'طقم ملابس بيبي قطن',
    price: 350,
    originalPrice: 450,
    description: 'طقم ملابس قطن 100% ناعم على بشرة الطفل، يتضمن 5 قطع (بودي سوت، بنطلون، قبعة، جوارب، بطانية). متوفر بألوان متعددة.',
    image: IMAGES.BABY_PRODUCTS_1,
    category: 'baby',
    stock: 45,
    featured: true,
    brand: 'Mothercare',
    rating: 4.9,
    reviewCount: 234,
    views: 3821,
    colors: [
      { name: 'وردي', image: IMAGES.BABY_PRODUCTS_1 },
      { name: 'أبيض', image: IMAGES.CATEGORY_BABY_3 },
      { name: 'أزرق فاتح', image: IMAGES.CATEGORY_BABY_5 },
    ],
  },
  {
    id: '3',
    name: 'كرسي سيارة للأطفال',
    price: 1800,
    description: 'كرسي سيارة آمن ومعتمد عالمياً، مع حماية جانبية معززة ونظام تثبيت سهل. مناسب من الولادة حتى 4 سنوات.',
    image: IMAGES.CATEGORY_BABY_2,
    category: 'baby',
    stock: 22,
    featured: false,
    brand: 'Chicco',
    rating: 4.7,
    reviewCount: 89,
    views: 1654,
    colors: [
      { name: 'أسود', image: IMAGES.CATEGORY_BABY_2 },
      { name: 'رمادي', image: IMAGES.CATEGORY_BABY_7 },
    ],
  },
  {
    id: '4',
    name: 'ألعاب تعليمية للرضع',
    price: 450,
    description: 'مجموعة ألعاب تعليمية آمنة تساعد على تطوير المهارات الحركية والحسية. مصنوعة من مواد غير سامة وقابلة للغسل.',
    image: IMAGES.BABY_PRODUCTS_1,
    category: 'baby',
    stock: 67,
    featured: false,
    brand: 'Johnson\'s',
    rating: 4.6,
    reviewCount: 156,
    views: 2187,
    colors: [
      { name: 'متعدد الألوان', image: IMAGES.BABY_PRODUCTS_1 },
    ],
  },
  {
    id: '5',
    name: 'حفاضات بامبرز - عبوة كبيرة',
    price: 280,
    description: 'حفاضات بامبرز فائقة الامتصاص، توفر حماية تدوم حتى 12 ساعة. مناسبة للبشرة الحساسة.',
    image: IMAGES.BABY_PRODUCTS_1,
    category: 'baby',
    stock: 120,
    featured: true,
    brand: 'Pampers',
    rating: 4.9,
    reviewCount: 567,
    views: 8932,
    colors: [
      { name: 'مقاس 3', image: IMAGES.BABY_PRODUCTS_1 },
      { name: 'مقاس 4', image: IMAGES.CATEGORY_BABY_3 },
      { name: 'مقاس 5', image: IMAGES.CATEGORY_BABY_5 },
    ],
  },

  // مستلزمات الأم
  {
    id: '6',
    name: 'وسادة حمل مريحة',
    price: 650,
    description: 'وسادة حمل متعددة الاستخدامات توفر الدعم للظهر والبطن أثناء الحمل، ويمكن استخدامها للرضاعة بعد الولادة. قابلة للغسل.',
    image: IMAGES.CATEGORY_MOTHER_1,
    category: 'mother',
    stock: 28,
    featured: true,
    brand: 'Mothercare',
    rating: 4.7,
    reviewCount: 98,
    views: 1876,
    colors: [
      { name: 'بيج', image: IMAGES.CATEGORY_MOTHER_1 },
      { name: 'رمادي', image: IMAGES.CATEGORY_MOTHER_3 },
    ],
  },
  {
    id: '7',
    name: 'حقيبة الأم والطفل',
    price: 850,
    description: 'حقيبة عملية وأنيقة بتصميم عصري، تحتوي على جيوب متعددة لتنظيم مستلزمات الطفل. مقاومة للماء وسهلة التنظيف.',
    image: IMAGES.CATEGORY_MOTHER_8,
    category: 'mother',
    stock: 35,
    featured: true,
    brand: 'Mothercare',
    rating: 4.8,
    reviewCount: 143,
    views: 2654,
    colors: [
      { name: 'وردي', image: IMAGES.CATEGORY_MOTHER_8 },
      { name: 'أسود', image: IMAGES.CATEGORY_MOTHER_6 },
      { name: 'بيج', image: IMAGES.CATEGORY_MOTHER_1 },
    ],
  },
  {
    id: '8',
    name: 'مشد ما بعد الولادة',
    price: 550,
    description: 'مشد طبي مريح يساعد على استعادة شكل الجسم بعد الولادة، مصنوع من قماش قابل للتنفس ومرن. متوفر بمقاسات مختلفة.',
    image: IMAGES.CATEGORY_MOTHER_3,
    category: 'mother',
    stock: 42,
    featured: false,
    brand: 'Mothercare',
    rating: 4.5,
    reviewCount: 76,
    views: 1432,
    colors: [
      { name: 'بيج', image: IMAGES.CATEGORY_MOTHER_3 },
      { name: 'أسود', image: IMAGES.CATEGORY_MOTHER_6 },
    ],
  },
  {
    id: '9',
    name: 'مضخة حليب كهربائية',
    price: 1200,
    description: 'مضخة حليب كهربائية هادئة وفعالة مع إعدادات متعددة للشفط. تأتي مع زجاجات تخزين وحقيبة حمل.',
    image: IMAGES.CATEGORY_MOTHER_1,
    category: 'mother',
    stock: 18,
    featured: false,
    brand: 'Philips Avent',
    rating: 4.9,
    reviewCount: 201,
    views: 3245,
    colors: [
      { name: 'أبيض', image: IMAGES.CATEGORY_MOTHER_1 },
    ],
  },

  // مستحضرات التجميل
  {
    id: '10',
    name: 'طقم مكياج كامل',
    price: 950,
    originalPrice: 1300,
    description: 'طقم مكياج احترافي يحتوي على ظلال عيون، أحمر شفاه، بلاشر، وفرش مكياج عالية الجودة. مناسب لجميع أنواع البشرة.',
    image: IMAGES.COSMETICS_1,
    category: 'cosmetics',
    stock: 55,
    featured: true,
    brand: 'MAC',
    rating: 4.8,
    reviewCount: 312,
    views: 5678,
    colors: [
      { name: 'ألوان دافئة', image: IMAGES.COSMETICS_1 },
      { name: 'ألوان باردة', image: IMAGES.CATEGORY_COSMETICS_4 },
    ],
  },
  {
    id: '11',
    name: 'كريم ترطيب فاخر',
    price: 680,
    description: 'كريم ترطيب غني بالفيتامينات والمواد الطبيعية، يعيد النضارة والحيوية للبشرة. مناسب للاستخدام اليومي.',
    image: IMAGES.CATEGORY_COSMETICS_2,
    category: 'cosmetics',
    stock: 73,
    featured: false,
    brand: 'Nivea',
    rating: 4.7,
    reviewCount: 189,
    views: 3421,
    colors: [
      { name: 'كلاسيكي', image: IMAGES.CATEGORY_COSMETICS_2 },
    ],
  },
  {
    id: '12',
    name: 'باليت ظلال عيون',
    price: 420,
    description: 'باليت ظلال عيون بـ 12 لون متنوع، تركيبة ناعمة وسهلة الدمج، ثبات طويل الأمد. مثالية للمكياج اليومي والسهرات.',
    image: IMAGES.CATEGORY_COSMETICS_4,
    category: 'cosmetics',
    stock: 89,
    featured: true,
    brand: 'Maybelline',
    rating: 4.6,
    reviewCount: 267,
    views: 4532,
    colors: [
      { name: 'نيود', image: IMAGES.CATEGORY_COSMETICS_4 },
      { name: 'سموكي', image: IMAGES.CATEGORY_COSMETICS_6 },
    ],
  },
  {
    id: '13',
    name: 'أحمر شفاه مات',
    price: 280,
    description: 'أحمر شفاه بتركيبة مات فاخرة، ثبات يدوم طوال اليوم، غني بالزيوت المرطبة. متوفر بألوان عصرية.',
    image: IMAGES.CATEGORY_COSMETICS_2,
    category: 'cosmetics',
    stock: 120,
    featured: false,
    brand: 'L\'Oréal',
    rating: 4.5,
    reviewCount: 423,
    views: 6789,
    colors: [
      { name: 'أحمر كلاسيكي', image: IMAGES.CATEGORY_COSMETICS_2 },
      { name: 'وردي', image: IMAGES.CATEGORY_COSMETICS_3 },
      { name: 'نيود', image: IMAGES.CATEGORY_COSMETICS_4 },
    ],
  },

  // العطور
  {
    id: '14',
    name: 'عطر نسائي فاخر',
    price: 1500,
    description: 'عطر نسائي راقي بتركيبة زهرية شرقية، ثبات استثنائي يدوم طوال اليوم. عبوة أنيقة 100 مل.',
    image: IMAGES.PERFUME_1,
    category: 'perfume',
    stock: 32,
    featured: true,
    brand: 'Dior',
    rating: 4.9,
    reviewCount: 456,
    views: 9876,
    colors: [
      { name: 'كلاسيكي', image: IMAGES.PERFUME_1 },
      { name: 'روز جولد', image: IMAGES.PERFUME_2 },
    ],
  },
  {
    id: '15',
    name: 'عطر رجالي عصري',
    price: 1350,
    description: 'عطر رجالي بتركيبة خشبية منعشة، مثالي للاستخدام اليومي والمناسبات الخاصة. عبوة 100 مل.',
    image: IMAGES.PERFUME_2,
    category: 'perfume',
    stock: 28,
    featured: true,
    brand: 'Versace',
    rating: 4.8,
    reviewCount: 321,
    views: 7654,
    colors: [
      { name: 'أزرق', image: IMAGES.PERFUME_2 },
    ],
  },
  {
    id: '16',
    name: 'عطر للأطفال',
    price: 450,
    description: 'عطر خفيف ولطيف مصمم خصيصاً للأطفال، برائحة منعشة وآمنة على البشرة الحساسة. عبوة 50 مل.',
    image: IMAGES.PERFUME_1,
    category: 'perfume',
    stock: 65,
    featured: false,
    brand: 'Johnson\'s',
    rating: 4.7,
    reviewCount: 178,
    views: 3456,
    colors: [
      { name: 'وردي', image: IMAGES.PERFUME_1 },
      { name: 'أزرق', image: IMAGES.PERFUME_2 },
    ],
  },
  {
    id: '17',
    name: 'مجموعة عطور مصغرة',
    price: 850,
    description: 'مجموعة من 5 عطور مصغرة بروائح متنوعة، مثالية للسفر أو كهدية. كل عبوة 15 مل.',
    image: IMAGES.PERFUME_2,
    category: 'perfume',
    stock: 48,
    featured: false,
    brand: 'Calvin Klein',
    rating: 4.6,
    reviewCount: 234,
    views: 4321,
    colors: [
      { name: 'مجموعة متنوعة', image: IMAGES.PERFUME_2 },
    ],
  },
  {
    id: '18',
    name: 'عطر شانيل الأصلي',
    price: 2200,
    description: 'عطر شانيل الكلاسيكي الأصلي، رائحة خالدة وفاخرة تناسب جميع المناسبات. عبوة 100 مل.',
    image: IMAGES.PERFUME_1,
    category: 'perfume',
    stock: 15,
    featured: true,
    brand: 'Chanel',
    rating: 5.0,
    reviewCount: 789,
    views: 15432,
    colors: [
      { name: 'كلاسيكي', image: IMAGES.PERFUME_1 },
    ],
  },
];
